// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// RxJS
import { Observable, of, forkJoin } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../_base/crud';

import { Global } from '../../../../shared/global';
// Models
import { CustomerRateModel } from '../_models/customerRate.model';
import { mergeMap } from 'rxjs/operators';
import { each } from 'lodash';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';

const API_CUSTOMERS_URL = Global.BASE_CUSTOMER_RATE_MASTER_ENDPOINT;
const API_URL = Global.BASE_CUSTOMER_RATE_BY_COMPANYMID;

@Injectable()
export class CustomerRateService {

	loggedCompanyMId: number;

	constructor(private http: HttpClient, private httpUtils: HttpUtilsService,
		private sharedService: ShareddataserviceService) { }

	getLoggedCompanyMId() {
		this.sharedService.companydata.subscribe(data => this.loggedCompanyMId = data[0]["CompanyMId"]);
	}

	// CREATE =>  POST: add a new customerRate to the server
	createCustomerRate(customerRate: CustomerRateModel): Observable<CustomerRateModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<CustomerRateModel>(API_CUSTOMERS_URL, customerRate, { headers: httpHeaders});
	}

	uploadImage(imageFile: File, imageName:any): Observable<any> {
		let formData = new FormData();
		formData.append('ImageFile', imageFile, imageFile.name);
		formData.append('imageName', imageName);

		const httpHeaders = new HttpHeaders();
		httpHeaders.set('Content-Type', 'multipart/form-data');

		const url = "Global.BASE_UPLOAD_CATEGORY_IMAGE_ENDPOINT";
		// Note: Add headers if needed (tokens/bearer)
		return this.http.post<any>(url, formData, { headers: httpHeaders });
	}

	// READ
	getAllCustomerRates(): Observable<CustomerRateModel[]> {
		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<CustomerRateModel[]>(URL);
	}

	getCustomerRateById(CustRateId: number): Observable<CustomerRateModel> {
		return this.http.get<CustomerRateModel>(API_CUSTOMERS_URL + `/${CustRateId}`);
	}

	// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	// Server should return filtered/sorted result
	findCustomerRates(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

		this.getLoggedCompanyMId();
		const URL = API_URL + this.loggedCompanyMId;
		return this.http.get<QueryResultsModel[]>(URL).pipe(
            mergeMap(res => {
                const result = this.httpUtils.baseFilter(res, queryParams);
                return of(result);
            })
        );
	}

	// UPDATE => PUT: update the customerRate on the server
	updateCustomerRate(CustRateId: number, customerRate: CustomerRateModel): Observable<any> {
		const httpHeader = this.httpUtils.getHTTPHeaders();
		return this.http.put(API_CUSTOMERS_URL + CustRateId, customerRate, { headers: httpHeader });
	}

	// UPDATE Status
	updateStatusForCustomerRate(customerRate: CustomerRateModel[], status: number): Observable<any> {
		const tasks$ = [];
		each(customerRate, element => {
			const _reviews = Object.assign({}, element);
			_reviews.ProductRate = status;
			tasks$.push(this.updateCustomerRate(_reviews.CustRateId, _reviews));
		});
		return forkJoin(tasks$);
	}

	// DELETE => delete the customerRate from the server
	deleteCustomerRate(CustRateId: number): Observable<CustomerRateModel> {
		const url = `${API_CUSTOMERS_URL}${CustRateId}`;
		return this.http.delete<CustomerRateModel>(url);
	}
}
